<div class="container-fluid">
  <div class="row">
    <ng-container *ngFor="let tab of config">
      <a
        *ngIf="tab.visible === undefined || tab.visible"
        class="custom-col text-center"
        routerLink="{{ tab.link }}"
        routerLinkActive
        #rla="routerLinkActive"
        [class.active]="rla.isActive"
        [routerLinkActiveOptions]="{exact: tab.exact}"
        [class.text-muted]="!rla.isActive"
        [class.text-body]="rla.isActive"
      >
        {{ tab.translationKey | translate }}
      </a>
    </ng-container>

    <ng-content></ng-content>
  </div>
</div>

